/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

console.log('JS loaded');

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import gsap from 'gsap';

function targetBlank() {
    // remove subdomain of current site's url and setup regex
    let internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");

    let a = document.getElementsByTagName('a'); // then, grab every link on the page
    for (let i = 0; i < a.length; i++) {
        let href = a[i].host; // set the host of each link
        if ((!internal.test(href) && !/^javascript/.test(a[i].getAttribute("href"))) || /\.pdf$/.test(a[i].getAttribute("href"))) { // make sure the href doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
        }
    }
}

let selectedFiles = [];
function downloadForm() {
    document.querySelectorAll('.multi-file-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const file = btn.dataset.file;

            if (btn.classList.contains('checked')) {
                btn.classList.remove('checked');
                const index = selectedFiles.indexOf(file);
                if (index > -1) {
                    selectedFiles.splice(index, 1);
                }
            } else {
                btn.classList.add('checked');
                selectedFiles.push(file);
            }
            document.querySelector('input[name="dateien"]').value = selectedFiles.join(';');
            console.log(selectedFiles);
            console.log(document.querySelector('input[name="dateien"]').value);

        });
    });

    if (document.querySelector('.multiform-download .btn-primary')) {
        document.querySelector('.multiform-download .btn-primary').addEventListener('click', (e) => {
            if (document.querySelector('.multiform-download input[name="dateien"]').value === '') {
                e.preventDefault()
                alert('Bitte ein Whitepaper auswählen!');
            }
        });

    }
}

function setCookie(cookie, sessionOnly=false) {
  let expiry = 0;
  if (!sessionOnly) {
    expiry = new Date(new Date().getTime() + 30 * 24 * 3600 * 1000).toUTCString();
  }
  document.cookie = cookie + "; path=/; expires=" + expiry;
}

// Störer
function hideStoerer() {
    console.log('Hide Störer');
    setCookie('stoerer=no');
    const body = document.querySelector('body');
    body.classList.remove('show-stoerer');
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');
    targetBlank();
    
    // Init Störer
    const stoerer = document.getElementById('top-stoerer');

    if (stoerer) {
        let btnC = document.getElementById('close-stoerer');
        btnC.addEventListener('click', function (e) {
            hideStoerer();
        });
    }
    if (!/stoerer=no/.test(document.cookie)) {
        const body = document.querySelector('body');
        body.classList.add('show-stoerer');
    }

    // menu
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('navbarScroll');
    const menuItems = gsap.utils.toArray('.navbar-nav .nav-item');

    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 992;


    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {

        let { isDesktop, isMobile } = context.conditions;
        // hide overlay
        gsap.set(overlay, {
            opacity: isMobile ? 0 : 1
        })
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.2
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.2
            }, "-=0.2")
            .to(overlay, {
                opacity: 1,
                height: "calc(100vh - 66px)",
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.1
            }, "-=0.1")
            .to('.navbar-collapse .bottom', {
                opacity: 1,
                duration: 0.4
            }, "-=0")
        navTl.pause();

        if (isMobile) {
            // toggle dropdowns in mobile
            const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

            dropdownToggles.forEach(toggle => {
                toggle.addEventListener('click', function (evt) {
                    console.log('click')
                    evt.preventDefault(); // Prevent default navigation behavior

                    const parent = this.parentElement;
                    const dropdownMenu = parent.querySelector('.dropdown-menu');

                    if (parent.classList.contains('open')) {
                        parent.classList.remove('open');
                    } else {
                        // Close any currently open dropdowns
                        dropdownToggles.forEach(toggleItem => {
                            const itemParent = toggleItem.parentElement;
                            if (itemParent !== parent) {
                                itemParent.classList.remove('open');
                            }
                        });


                        parent.classList.add('open');
                    }
                });
            });
        }

        if (menuBtn) {
            menuBtn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (!menuOpen) {
                    navTl.play();
                    $(".navbar").addClass("open")
                    menuOpen = true;
                } else {
                    navTl.reverse();
                    $(".navbar").removeClass("open")
                    menuOpen = false;
                }
            })
        }
    });

    if(document.querySelector('.guided-tour')){
        initTour();
    }

    downloadForm();
    // nav shrink
    $(document).ready(function () {
        $(window).scroll(function (e) {
            const delta = $(this).scrollTop() - (this.previousScrollTop || 0);
            this.previousScrollTop = $(this).scrollTop();
            // console.log("Scroll delta:", delta);
            // console.log(e)
            $("header").toggleClass("navbar-shrink", delta > 0)
        });
    });

    // accordion

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {

        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");

            var panel = this.querySelector(".panel");

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }

        });

    }

    // swiper
    const swiper = new Swiper('.mySwiper', {
        modules: [Navigation, Pagination],
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        freeMode: true,
        freeModeMomentumBounce: false,
        freeModeMomentumVelocityRatio: 0.3,
        breakpoints: {
            1200: {
                slidesPerView: '3',
            },
        },
    });
});


function initTour() {
    console.log('init Tour')
    let currentSlide = 0;
    let slides = document.querySelectorAll('.guided-tour .slide');

    let prev = document.querySelector('.guided-tour nav .back');
    let next = document.querySelector('.guided-tour nav .next');

    prev.addEventListener("click", () => {

        gotoPrevSlide()
    });

    next.addEventListener("click", () => {

        gotoNextSlide()
    });


    function gotoNextSlide() {
        if (currentSlide < slides.length - 1) {
            let currentImage = $('.guided-tour .slide' + currentSlide + ' img').attr('src');
            currentSlide++;
            let nextImage = $('.guided-tour .slide' + currentSlide + ' img').attr('src');
            $('.guided-tour .slide').addClass('hide');
            //console.log(nextImage + ' = ' + currentImage)

            if (currentImage !== nextImage)
                gsap.set('.guided-tour .slide' + currentSlide + ' .slide_bg', {opacity: 0});
            gsap.set('.guided-tour .slide' + currentSlide + ' .slide_svg', {opacity: 0});
            gsap.set('.guided-tour .slide' + currentSlide + ' .slide_box', {opacity: 0});
            $('.guided-tour .slide' + currentSlide).removeClass('hide');
            showSlide(currentSlide,currentImage !== nextImage);
            prev.classList.remove('inactive');
            if(currentSlide === slides.length - 1 )
                next.classList.add('inactive');
        }
    }


    function gotoPrevSlide() {
        if (currentSlide > 0) {
            let currentImage = $('.guided-tour .slide' + currentSlide + ' img').attr('src');
            $('.guided-tour .slide' + currentSlide).addClass('hide');
            currentSlide--;
            let nextImage = $('.guided-tour .slide' + currentSlide + ' img').attr('src');

            console.log(nextImage + ' = ' + currentImage)
            if (currentImage !== nextImage)
                gsap.set('.guided-tour .slide' + currentSlide + ' .slide_bg', {opacity: 0});
            gsap.set('.guided-tour .slide' + currentSlide + ' .slide_svg', {opacity: 0});
            gsap.set('.guided-tour .slide' + currentSlide + ' .slide_box', {opacity: 0});
            $('.guided-tour .slide' + currentSlide).removeClass('hide');
            showSlide(currentSlide,currentImage !== nextImage);

            next.classList.remove('inactive');
            if(currentSlide === 0 )
                prev.classList.add('inactive');
        }
    }

// Add keyboard support for next and previous slide with arrow keys
    document.addEventListener('keydown', function (event) {

        if (event.key === 'ArrowRight') {
            console.log(event.key)
            gotoNextSlide();
        } else if (event.key === 'ArrowLeft') {
            console.log(event.key)
            gotoPrevSlide();
        }
    });


    function showSlide(id, fadeBG) {
        const bg = document.querySelector('.slide' + id + ' .slide_bg');
        const svg = document.querySelector('.slide' + id + ' .slide_svg');
        const box = document.querySelector('.slide' + id + ' .slide_box');

        let tslide = gsap.timeline({
            onComplete: function () {
                console.log('complete');
            }
        });
        if (fadeBG) {
            tslide.to(bg, {
                opacity: 1,
                duration: 1
            }, '+=0');
        }


        if (svg) {
            let tslideS = gsap.timeline({
                yoyo: true,
                repeat: -1
            });
            tslideS.to(svg, {
                opacity: 1,
                duration: 1
            }, '+=0');

            tslide.add(tslideS)
        }

        tslide.to(box, {
            opacity: 1,
            duration: 0.4
        }, '-=0.2');
    }

    let nextBtns = document.querySelectorAll('.btn-nextSlide') || {};

    nextBtns.forEach(nextBtn => {
        nextBtn.addEventListener("click", () => {
            gotoNextSlide()
        });

    })


}



